import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env file.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  },
  global: {
    headers: {
      'x-application-name': 'profitiq-ai'
    }
  }
});

// Add type safety for user profiles
export type Profile = {
  id: string;
  email: string;
  full_name: string | null;
  company: string | null;
  industry: string | null;
  phone: string | null;
  subscription_tier: string;
  created_at: string;
  updated_at: string;
};

// Add secure helper functions
export const secureApiCall = async <T>(
  apiCall: () => Promise<T>,
  errorMessage = 'An error occurred'
): Promise<T> => {
  try {
    return await apiCall();
  } catch (error) {
    console.error('API Error:', error);
    throw new Error(errorMessage);
  }
};